export default __webpack_public_path__ + "static/media/line3_2.4c367ed9.svg";